import { lazy } from 'react';
import { FaChartLine } from 'react-icons/fa';
import { MdOutlinePlaylistAdd } from 'react-icons/md';

const PainelDashboard = lazy(() => import('./Dashboard').then((m) => ({ default: m.PainelDashboard })));
const CadastroDeposito = lazy(() => import('./Deposito'));
const ModalDeposito = lazy(() => import('./Deposito/children/Form'));
const CadastroEstacao = lazy(() => import('./Estacao'));
const FormEstacao = lazy(() => import('./Estacao/children/Form'));
const CadastroMotivo = lazy(() => import('./Motivo'));
const FormMotivo = lazy(() => import('./Motivo/children/Form'));
const ModalSelecaoEstacao = lazy(() => import('./OrdenacaoEstacao/children/ModalSelecaoEstacao'));
const CadastroOrdenacao = lazy(() => import('./OrdenacaoEstacao'));
const CadastroEndereco = lazy(() => import('./Endereco'));
const EnderecoEdit1 = lazy(() => import('./Endereco/Components/Edit').then((m) => ({ default: m.EnderecoEdit1 })));
const EnderecoCreatee = lazy(() => import('./Endereco/Components/Create').then((m) => ({ default: m.EnderecoCreatee })));
const CadastroUsuario = lazy(() => import('../Configuracao/Usuario'));
const UsuarioEdit = lazy(() => import('../Configuracao/Usuario/Components/Edit').then((m) => ({ default: m.UsuarioEdit })));
const UsuarioCreate = lazy(() => import('../Configuracao/Usuario/Components/Create').then((m) => ({ default: m.UsuarioCreate })));
const ListPermissoes = lazy(() => import('../Configuracao/Usuario/permissoes/ListPermissoes').then((m) => ({ default: m.ListPermissoes })));
const EditPermissoes = lazy(() => import('../Configuracao/Usuario/permissoes/edit').then((m) => ({ default: m.EditPermissoes })));
const UsuarioPermissionCreate = lazy(() => import('../Configuracao/Usuario/permissoes/create').then((m) => ({ default: m.UsuarioPermissionCreate })));
const Ordenacao = lazy(() => import('./OrdenacaoEstacao/children/OrdenacaoEstacao'));
const CadastroCodigoComposto = lazy(() => import('./CodigoComposto'));
const ModalCodigoComposto = lazy(() => import('./CodigoComposto/children/Form'));
const EAN128Config = lazy(() => import('./CodigoComposto/children/EAN128Config'));
const FindEans = lazy(() => import('./CodigoComposto/children/FindEans'));

const Module = {
  menuItem: {
    to: '/painel',
    id: 1,
    title: 'Cadastros',
    icon: FaChartLine,
    childrens: [
      {
        to: '/painel/cadastro-de-depositos',
        title: 'Depósitos',
        fullTitle: 'Cadastro de Depósitos',
        icon: MdOutlinePlaylistAdd,
        id: 1
      },
      {
        to: '/painel/cadastro-de-estacoes',
        title: 'Estações',
        fullTitle: 'Cadastro de Estações',
        icon: MdOutlinePlaylistAdd,
        id: 2
      },
      {
        to: '/painel/cadastro-de-enderecos1',
        title: 'Endereços',
        fullTitle: 'Cadastro de Endereços',
        icon: MdOutlinePlaylistAdd,
        id: 3
      },
      {
        to: '/painel/cadastro-de-motivos',
        title: 'Motivos',
        fullTitle: 'Cadastro de Motivos',
        icon: MdOutlinePlaylistAdd,
        id: 4
      },
      {
        to: '/painel/cadastro-de-ordenacao',
        title: 'Ordenação',
        fullTitle: 'Cadastro de Ordenação Estação',
        icon: MdOutlinePlaylistAdd,
        id: 5
      },
      {
        to: '/painel/cadastro-do-codigo-composto',
        title: 'Código composto',
        fullTitle: 'Código composto',
        icon: MdOutlinePlaylistAdd,
        id: 6
      },
      {
        to: '/painel/cadastro-de-usuarios',
        title: 'Cadastro de Usuários',
        fullTitle: 'Cadastro de Usuários',
        icon: MdOutlinePlaylistAdd,
        id: 81
      },
      {
        to: '/configuracao/permissao-de-usuarios',
        title: 'Permissão de Usuários',
        fullTitle: 'Permissão de Usuários',
        icon: MdOutlinePlaylistAdd,
        id: 82
      },
      {
        to: '/configuracao/permissao-de-filiais',
        title: 'Permissão de Filiais',
        fullTitle: 'Permissão de Filiais',
        icon: MdOutlinePlaylistAdd,
        id: 83
      }
    ],
  },

  routes: [
    {
      path: '',
      element: <PainelDashboard />,
    },
    {
      path: 'painel',
      element: <PainelDashboard />,
    },
    {
      path: '/painel/cadastro-de-depositos',
      element: <CadastroDeposito />,
      children: [
        { path: ':id', element: <ModalDeposito /> },
        { path: 'novo', element: <ModalDeposito /> },
      ],
    },
    {
      path: '/painel/cadastro-de-estacoes',
      element: <CadastroEstacao />,
      children: [
        { path: ':id', element: <FormEstacao /> },
        { path: 'novo', element: <FormEstacao /> },
      ],
    },
    {
      path: '/painel/cadastro-de-enderecos1',
      element: <CadastroEndereco />,
      children: [
        { path: ':id', element: <EnderecoEdit1 /> },
        { path: 'novo', element: <EnderecoCreatee /> },
      ],
    },
    {
      path: '/painel/cadastro-de-usuarios',
      element: <CadastroUsuario />,
      children: [
        { path: ':id', element: <UsuarioEdit /> },
        { path: 'novo', element: <UsuarioCreate /> },
        { path: 'listapermissoes/:id', element: <ListPermissoes /> },
        { path: 'listapermissoes/:id/:idpermissao', element: <EditPermissoes /> },
        { path: 'listapermissoes/:id/novo', element: <UsuarioPermissionCreate /> },
      ],
    },
    {
      path: '/painel/cadastro-de-motivos',
      element: <CadastroMotivo />,
      children: [
        { path: ':id', element: <FormMotivo /> },
        { path: 'novo', element: <FormMotivo /> },
      ],
    },
    {
      path: '/painel/cadastro-de-ordenacao',
      element: <CadastroOrdenacao />,
      children: [
        { path: 'novo', element: <ModalSelecaoEstacao /> },
        { path: ':id', element: <ModalSelecaoEstacao /> },
        { path: 'novo/:idestacao', element: <Ordenacao /> },
      ],
    },
    {
      path: '/painel/cadastro-do-codigo-composto',
      element: <CadastroCodigoComposto />,
      children: [
        { path: 'novo', element: <ModalCodigoComposto /> },
        { path: 'novo/:id', element: <EAN128Config /> },
        { path: 'editar', element: <ModalCodigoComposto /> },
        { path: 'editar/:id', element: <EAN128Config /> },
        { path: ':codigoProduto/encontrar', element: <FindEans /> }
      ],
    },
  ],
};

export default Module;
